import { FaceRecognitionIcon } from './FaceRecognitionIcon';

/**
 * author: Michael Richins
 * id FDC4CFE0-5CA9-4F8E-A126-EC98BF900228
 * name face-recognition
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-recognition.svg
 * tags
 * - Photography 
 */
export const FacialRecognitionIcon = FaceRecognitionIcon;
export default FacialRecognitionIcon